import { render, staticRenderFns } from "./SingleQuestionEditor.vue?vue&type=template&id=8e22d9a8"
import script from "./SingleQuestionEditor.vue?vue&type=script&lang=js"
export * from "./SingleQuestionEditor.vue?vue&type=script&lang=js"
import style0 from "./SingleQuestionEditor.vue?vue&type=style&index=0&id=8e22d9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports